import styled from "styled-components";

export const Heading = styled.h1`
  margin: 0 0 1rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: calc(1.4rem * 1.25);
  color: #484848;
`;
